(function () {
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest(
        'a[data-instant-action-type="add-to-instant-cart"]'
      );

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var variantId =
        btn.getAttribute("data-instant-action-variant-id") ||
        (btn.href.match(/\/cart\/(\d+):/) || [])[1];

      if (!variantId) {
        console.warn("Variant ID not found for Instant ATC button");
        return;
      }

      btn.style.setProperty("--direct-cart-loader-color", getComputedStyle(btn).color);
      btn.classList.add("is-loading");
      btn.setAttribute("aria-busy", "true");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Cart add failed");
          return res.json();
        })
        .then(function () {
          if (typeof window.refreshMinicart === "function") {
            window.refreshMinicart();
          }

          var drawer = document.getElementById("kwik-cart-drawer");
          var overlay = document.getElementById("cart-overlay");

          if (drawer && overlay) {
            drawer.hidden = false;
            overlay.hidden = false;
            drawer.setAttribute("aria-hidden", "false");
            document.documentElement.style.overflow = "hidden";
          } else {
            var cartTrigger = document.querySelector("[data-open-cart]");
            if (cartTrigger) cartTrigger.click();
          }
        })
        .catch(function (err) {
          console.error("Mini cart ATC error:", err);

          // Fallback: agar mini cart open/add fail ho to normal cart URL par bhej do
          window.location.href = btn.href;
        })
        .finally(function () {
          btn.classList.remove("is-loading");
          btn.style.removeProperty("--direct-cart-loader-color");
          btn.removeAttribute("aria-busy");
        });
    },
    true
  );
})();

(function () {
  function updateCartCount(count) {
    document
      .querySelectorAll(
        '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .visually-hidden'
      )
      .forEach(function (el) {
        el.textContent = count;
      });

    var cartIcon = document.getElementById("cart-icon-bubble");
    if (cartIcon) {
      cartIcon.classList.toggle("header__cart--empty", count === 0);
    }
  }

  function openCartDrawer() {
    var drawer = document.getElementById("kwik-cart-drawer");
    var overlay = document.getElementById("cart-overlay");

    if (drawer && overlay) {
      drawer.hidden = false;
      overlay.hidden = false;
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      return;
    }

    var cartTrigger = document.querySelector("[data-open-cart], #cart-icon-bubble");
    if (cartTrigger) cartTrigger.click();
  }

  function getProductHandle(url) {
    var match = url.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  function hasDirectToCartTag(product) {
    var tags = product.tags || [];
    if (typeof tags === "string") {
      tags = tags.split(",");
    }

    return tags.some(function (tag) {
      return String(tag).trim().toLowerCase().replace(/\s+/g, "-") === "direct-to-cart";
    });
  }

  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest(
        'a[data-instant-action-type="open-page"][href*="/products/"]'
      );
      if (!link) return;

      var productForm = link.closest("[data-instant-form-product-url]");
      var productUrl =
        (productForm && productForm.getAttribute("data-instant-form-product-url")) ||
        link.getAttribute("href");
      var handle = getProductHandle(productUrl);

      if (!handle || link.dataset.noVariantCartProcessing === "true") return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      link.dataset.noVariantCartProcessing = "true";
      link.style.setProperty("--direct-cart-loader-color", getComputedStyle(link).color);
      link.classList.add("is-loading");
      link.setAttribute("aria-busy", "true");

      fetch("/products/" + handle + ".js")
        .then(function (res) {
          if (!res.ok) throw new Error("Product not found");
          return res.json();
        })
        .then(function (product) {
          if (!hasDirectToCartTag(product) || !product.variants || product.variants.length !== 1) {
            window.location.href = productUrl;
            return null;
          }

          var variant = product.variants[0];
          if (!variant.available) {
            window.location.href = productUrl;
            return null;
          }

          return fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: variant.id,
              quantity: 1,
            }),
          });
        })
        .then(function (res) {
          if (!res) return null;
          if (!res.ok) throw new Error("Cart add failed");
          return fetch("/cart.js");
        })
        .then(function (res) {
          if (!res) return null;
          return res.json();
        })
        .then(function (cart) {
          if (!cart) return;

          updateCartCount(cart.item_count);
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: cart,
            })
          );
          openCartDrawer();
        })
        .catch(function () {
          window.location.href = productUrl;
        })
        .finally(function () {
          link.classList.remove("is-loading");
          link.style.removeProperty("--direct-cart-loader-color");
          link.removeAttribute("aria-busy");
          delete link.dataset.noVariantCartProcessing;
        });
    },
    true
  );
})();
